import React from "react";
import {
    FaArrowLeft, FaShoppingCart, FaHeart, FaCheckCircle,
    FaInfoCircle, FaHourglassHalf, FaPlus, FaMinus, FaShieldAlt
} from "react-icons/fa";
import { myCustomTheme } from "../../Theme";
import { MASTER_COLOR_PALETTE } from "../../Pages/OurProduct/constants";
import { getDynamicPrices } from "../../Pages/OurProduct/utils/priceUtils";
import ReviewSection from "./ReviewSection";
import "./style/ProductDetail.css";

const ProductDetail = ({
    selectedProduct,
    setSelectedProduct,
    mainImage,
    setMainImage,
    userDetails,
    setUserDetails,
    selectedInch,
    setSelectedInch,
    onAddToCart,
    onAddToWishlist,
    onBuyNow,
    newReview,
    setNewReview,
    showToast
}) => {
    const isCustomized = selectedProduct?.type === "Customize";
    const dynamicPrices = getDynamicPrices(selectedProduct, selectedInch, userDetails.quantity);

    const displaySP = isCustomized
    ? dynamicPrices.sp
    : Math.round((selectedProduct?.sellingPrice || 0) * 1.18);

const displayMRP = isCustomized
    ? dynamicPrices.mrp
    : Math.round((selectedProduct?.mrp || 0) * 1.18);

const discountPercent = displayMRP > 0
    ? Math.round(((displayMRP - displaySP) / displayMRP) * 100)
    : selectedProduct?.discount;

    const imagesArray = selectedProduct?.images || [];

    return (
        <div
            className="modern-product-page"
            style={{
                backgroundColor: myCustomTheme.colors.header_footer_bg,
                boxShadow: myCustomTheme.shadows.soft,
                borderRadius: "30px"
            }}
        >
            <button
                className="back-btn"
                onClick={() => setSelectedProduct(null)}
                style={{
                    backgroundColor: myCustomTheme.colors.button_bg,
                    color: myCustomTheme.colors.button_text
                }}
            >
                <FaArrowLeft /> Back
            </button>

            <div className="modern-product-layout">

                {/* GALLERY */}
                <div className="gallery-section">
                    {imagesArray.length > 1 && (
                        <div className="thumbnail-column">
                            {imagesArray.map((img, idx) => (
                                <img
                                    key={idx}
                                    src={img}
                                    alt=""
                                    className="thumb-image"
                                    style={{
                                        border: mainImage === img
                                            ? `3px solid ${myCustomTheme.colors.button_bg}`
                                            : `2px solid ${myCustomTheme.colors.high_light}`,
                                        borderRadius: "14px"
                                    }}
                                    onClick={() => setMainImage(img)}
                                />
                            ))}
                        </div>
                    )}
                    <div
                        className="main-image-box"
                        style={{ borderRadius: "20px", backgroundColor: myCustomTheme.colors.bg_secondary }}
                    >
                        {discountPercent > 0 && (
                            <div className="offer-badge">-{discountPercent}% OFF</div>
                        )}
                        <img
                            src={mainImage}
                            alt={selectedProduct?.name}
                            className="main-product-image"
                        />
                    </div>
                </div>

                {/* INFO */}
                <div className="product-info-section">
                    <span
                        className="type-inline-pill"
                        style={{
                            backgroundColor: myCustomTheme.colors.high_light,
                            color: myCustomTheme.colors.heading,
                            borderRadius: "6px"
                        }}
                    >
                        {selectedProduct?.type}
                    </span>

                    <h1
                        className="product-title"
                        style={{
                            color: myCustomTheme.colors.heading,
                            fontFamily: myCustomTheme.typography.heading_font,
                            marginTop: "10px"
                        }}
                    >
                        {selectedProduct?.name}
                    </h1>

                   <div className="modern-price-box">
    <span className="new-price" style={{ color: myCustomTheme.colors.heading }}>
        Rs.{displaySP}
    </span>
    {displayMRP > displaySP && (
        <span className="old-price" style={{ color: myCustomTheme.colors.menu_text }}>
            Rs.{displayMRP}
        </span>
    )}
    {discountPercent > 0 && (
        <span
            className="offer-percent"
            style={{
                backgroundColor: myCustomTheme.colors.high_light,
                color: myCustomTheme.colors.heading,
                borderRadius: "30px"
            }}
        >
            {discountPercent}% OFF
        </span>
    )}
</div>

{/* GST included note */}
<div style={{
    display: "flex",
    alignItems: "center",
    gap: "7px",
    marginTop: "8px",
    marginBottom: "4px",
    padding: "8px 14px",
    background: "#f0fdf4",
    border: "1.5px solid #86efac",
    borderRadius: "10px",
    fontSize: "12px",
    fontWeight: "600",
    color: "#15803d"
}}>
    <FaShieldAlt style={{ color: "#16a34a", fontSize: "12px", flexShrink: 0 }} />
    18% GST included in MRP &amp; discounted price
</div>

                    {/* SELECTORS ROW */}
                    <div
                        className="inline-purchase-selectors-row"
                        style={{
                            backgroundColor: myCustomTheme.colors.bg_secondary,
                            borderColor: myCustomTheme.colors.high_light,
                            borderRadius: "16px"
                        }}
                    >
                        {/* QUANTITY */}
                        <div className="selector-block-item">
                            <span style={{ fontSize: "12px", fontWeight: "700", color: myCustomTheme.colors.menu_text }}>
                                Quantity
                            </span>
                            <div
                                className="qty-button-group"
                                style={{
                                    border: `1.5px solid ${myCustomTheme.colors.high_light}`,
                                    borderRadius: "12px",
                                    backgroundColor: myCustomTheme.colors.header_footer_bg
                                }}
                            >
                                <button
                                    className="qty-action-btn"
                                    onClick={() => setUserDetails({ ...userDetails, quantity: Math.max(1, userDetails.quantity - 1) })}
                                    style={{ color: myCustomTheme.colors.heading }}
                                >
                                    <FaMinus />
                                </button>
                                <span className="qty-display-text" style={{ color: myCustomTheme.colors.heading }}>
                                    {userDetails.quantity}
                                </span>
                                <button
                                    className="qty-action-btn"
                                    onClick={() => setUserDetails({ ...userDetails, quantity: userDetails.quantity + 1 })}
                                    style={{ color: myCustomTheme.colors.heading }}
                                >
                                    <FaPlus />
                                </button>
                            </div>
                        </div>

                        {/* COLORS */}
                        {selectedProduct?.availableColors && selectedProduct.availableColors.length > 0 && (
                            <div className="selector-block-item">
                                <span style={{ fontSize: "12px", fontWeight: "700", color: myCustomTheme.colors.menu_text }}>
                                    Color
                                </span>
                                <div className="inline-visual-colors-tray">
                                    {selectedProduct.availableColors.map((colorId) => {
                                        const colorObj = MASTER_COLOR_PALETTE.find(c => c.id === colorId);
                                        if (!colorObj) return null;
                                        return (
                                            <button
                                                key={colorId}
                                                title={colorObj.name}
                                                className={`visual-color-circle-btn ${userDetails.color === colorId ? "active-circle-dot" : ""}`}
                                                style={{ backgroundColor: colorObj.hex }}
                                                onClick={() => setUserDetails({ ...userDetails, color: colorId })}
                                            />
                                        );
                                    })}
                                </div>
                            </div>
                        )}

                        {/* INCH SELECTOR (only for customize) */}
                        {isCustomized && (
                            <div className="selector-block-item">
                                <span style={{ fontSize: "12px", fontWeight: "700", color: myCustomTheme.colors.menu_text }}>
                                    Size (inches)
                                </span>
                                <select
                                    value={selectedInch}
                                    onChange={(e) => setSelectedInch(e.target.value)}
                                    style={{
                                        height: "48px",
                                        padding: "0 12px",
                                        border: `1.5px solid ${myCustomTheme.colors.high_light}`,
                                        borderRadius: "12px",
                                        background: myCustomTheme.colors.header_footer_bg,
                                        color: myCustomTheme.colors.heading,
                                        fontWeight: "700",
                                        fontSize: "15px",
                                        outline: "none",
                                        cursor: "pointer"
                                    }}
                                >
                                    {["1","2","3","4","5","6","7","8","9"].map(inch => (
                                        <option key={inch} value={inch}>{inch}"</option>
                                    ))}
                                </select>
                            </div>
                        )}
                    </div>

                    {/* LIMITED OFFER TIMER */}
                    <div
                        className="timer-box"
                        style={{ borderColor: myCustomTheme.colors.high_light, borderRadius: "12px" }}
                    >
                        <FaHourglassHalf style={{ marginRight: "8px", verticalAlign: "middle" }} />
                        <span style={{ verticalAlign: "middle" }}>Limited Offer System Profile Enabled</span>
                    </div>

                    {/* HIGHLIGHTS */}
                    <div className="highlight-box">
                        <div
                            className="highlight-item"
                            style={{
                                backgroundColor: myCustomTheme.colors.bg_secondary,
                                color: myCustomTheme.colors.heading,
                                borderRadius: "10px"
                            }}
                        >
                            <FaCheckCircle style={{ color: myCustomTheme.colors.icon_color }} />
                            Certified Unique Reference ID: {selectedProduct?.id}
                        </div>
                        <div
                            className="highlight-item"
                            style={{
                                backgroundColor: myCustomTheme.colors.bg_secondary,
                                color: myCustomTheme.colors.heading,
                                borderRadius: "10px"
                            }}
                        >
                            <FaInfoCircle style={{ color: myCustomTheme.colors.icon_color }} />
                            Product Information Certified Unique Reference ID: PROD-128449
                        </div>
                        <div
                            className="highlight-item"
                            style={{
                                backgroundColor: myCustomTheme.colors.bg_secondary,
                                color: myCustomTheme.colors.heading,
                                borderRadius: "10px"
                            }}
                        >
                            <FaCheckCircle style={{ color: myCustomTheme.colors.icon_color }} />
                            Verified Multi-Tier Quality Performance Matrix
                        </div>
                    </div>

                    <p className="product-description" style={{ color: myCustomTheme.colors.menu_text }}>
                        {selectedProduct?.description}
                    </p>

                    {/* ACTION BUTTONS */}
                    <div className="modern-buttons">
                        <button
                            className="buy-now-btn"
                            onClick={onBuyNow}
                            style={{
                                backgroundColor: myCustomTheme.colors.button_bg,
                                color: myCustomTheme.colors.button_text,
                                borderRadius: "12px"
                            }}
                        >
                            BUY NOW
                        </button>
                        <button
                            className="cart-icon-btn"
                            onClick={(e) => onAddToCart(selectedProduct, e)}
                            style={{
                                backgroundColor: myCustomTheme.colors.bg_secondary,
                                color: myCustomTheme.colors.heading,
                                borderRadius: "12px"
                            }}
                        >
                            <FaShoppingCart />
                        </button>
                        <button
                            className="wishlist-icon-btn"
                            onClick={(e) => onAddToWishlist(selectedProduct, e)}
                            style={{
                                backgroundColor: myCustomTheme.colors.high_light,
                                color: myCustomTheme.colors.heading,
                                borderRadius: "12px"
                            }}
                        >
                            <FaHeart />
                        </button>
                    </div>
                </div>
            </div>

            {/* REVIEWS */}
            <ReviewSection
                selectedProduct={selectedProduct}
                newReview={newReview}
                setNewReview={setNewReview}
                setSelectedProduct={setSelectedProduct}
                showToast={showToast}
            />
        </div>
    );
};

export default ProductDetail;